import { DOMAINS } from "./constants";

export default function DelegationDomains() {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8 mb-10">
          <div className="lg:col-span-7">
            <p className="text-xs tracking-[0.3em] uppercase font-body font-semibold text-cvc-red">The eight domains we delegate</p>
            <h2 className="font-heading text-4xl md:text-5xl text-cvc-navy mt-4 leading-tight">
              Every hat you're wearing, handed off to the right shoulders.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pt-3">
            <p className="font-body text-cvc-ink-soft text-lg leading-relaxed">
              A scaled-up Company has clear ownership of all eight domains. We walk through each one with you,
              identify the bottleneck, structure the seat, hire the right person, and hand the duty off — until you
              end up with nothing left to do.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {DOMAINS.map((d) => {
            const Icon = d.icon;
            return (
              <div
                data-testid={`domain-${d.name.toLowerCase()}`}
                key={d.name}
                className="rounded-2xl border border-cvc-border bg-white p-6 transition-transform hover:-translate-y-1"
              >
                <Icon size={32} weight="duotone" className="text-cvc-red" />
                <h3 className="font-heading text-2xl text-cvc-navy mt-4">{d.name}</h3>
                <p className="font-body text-sm text-cvc-ink-soft mt-2 leading-relaxed">{d.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
